/**
 * 全站权限配置
 *
 */
import router from '@/router/router'
import store from '@/store'
import { validatenull } from '@/util/validate'
import { getToken } from '@/util/auth'
import { urlParams } from '@/util'
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css' // progress bar style
import website from '@/config/website'
import PageRouter from '@/router/page/'
import ViewsRouter from '@/router/views/'
import { isEmpty } from 'lodash-es'

import { initMap } from '@/plugins/plugins.amap.js'
NProgress.configure({ showSpinner: false })

// 登录白名单
const whiteList = ['/login', '/auth-redirect', '/bind', '/register', '/test']
const lockPage = website.lockPage // 锁屏页

const getTab = (to) => {
  const value = to.query.src || to.fullPath
  const label = to.query.name || to.name
  const meta = to.meta || router.$avueRouter.meta || {}
  const i18n = to.query.i18n
  if (meta.isTab !== false && !validatenull(value) && !validatenull(label) && !meta.hideInMenu) {
    store.commit('ADD_TAG', {
      label,
      value,
      params: to.params,
      query: to.query,
      meta: (() => {
        if (!i18n) {
          return meta
        }
        return {
          i18n
        }
      })(),
      group: router.$avueRouter.group || []
    })
  }
}
router.beforeEach((to, from, next) => {
  const meta = to.meta || {}
  const isMenu = meta.menu === undefined ? to.query.menu : meta.menu
  store.commit('SET_IS_MENU', isMenu === undefined)
  const closeAllTag = urlParams(to.fullPath, 'closeAllTag')
  if (getToken()) {
    initMap()
    store.dispatch('GetMenu').then((menu) => {
      router.$avueRouter.formatRoutes(menu, true)
      router.addRoutes([...PageRouter, ...ViewsRouter])
    })
    if (store.getters.isLock && to.path !== lockPage) {
      // 如果系统激活锁屏，全部跳转到锁屏页
      next({ path: lockPage })
    } else if (to.path === '/login') {
      // 如果登录成功访问登录页跳转到主页
      next({ path: '/' })
    } else if (closeAllTag) {
      store.commit('DEL_ALL_TAG')
      const _query = to.query
      delete _query.closeAllTag
      next({ path: to.path, query: _query, params: to.params })
    } else {
      // 如果用户信息为空则获取用户信息，获取用户信息失败，跳转到登录页
      // if (store.getters.roles.length === 0) {
      if (isEmpty(store.getters.userInfo)) {
        store.dispatch('GetUserInfo').then((res) => {
          const { code } = res || {}
          if (code !== 0) {
            store.dispatch('FedLogOut').then(() => {
              next({ path: '/login' })
            })
            return
          }
          getTab(to)
          next()
        })
      } else {
        getTab(to)
        next()
      }
    }
  } else {
    // 判断是否需要认证，没有登录访问去登录页
    if (whiteList.indexOf(to.path) !== -1) {
      // 在免登录白名单，直接进入
      next()
    } else {
      next('/login?redirect=index') // 否则全部重定向到登录页
      NProgress.done()
    }
  }
})

router.afterEach(() => {
  NProgress.done()
  let title = store.getters.tag.label
  const i18n = store.getters.tag.meta.i18n
  title = router.$avueRouter.generateTitle(title, i18n)
  // 根据当前的标签也获取label的值动态设置浏览器标题
  router.$avueRouter.setTitle(title)
})
